import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  Button,
  Form,
  Badge,
  Dropdown,
  Row,
  Col,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faSearch,
  faEllipsisV,
  faUsers,
  faFileAlt,
  faUserTie,
  faPen,
  faEye,
  faToggleOff,
  faToggleOn,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import "./plans.css";
import CreatePlanModal from "components/Modals/CreatePlanModal";
import { useNavigate } from "react-router-dom";
import { CompanyService } from "Services/CompanyService";
import { toast } from "react-toastify";
import TablePagination from "components/Pagination/Table.paginaition";

const PlanList = () => {
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [plan, setPlan] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);

  const navigate = useNavigate();

  const getAllPlan = async () => {
    try {
      const res = await CompanyService.getAllPlan(currentPage, perPage, search);

      if (res.status === 200) {
        const list = res?.data?.data?.data || [];
        const totalCount = res.data?.data?.total || 0;

        const normalizedPlans = list.map((p: any) => ({
          ...p,
          status: (p.status || "").toUpperCase(),
        }));

        setPlan(normalizedPlans);
        setTotal(totalCount);
      }
    } catch (error) {
      toast.error("Unable to fetch plan");
    }
  };

  useEffect(() => {
    getAllPlan();
  }, [currentPage,perPage,search]);

  const updateStatus = async (item: any) => {
    try {
      const newStatus =
        item.status?.toUpperCase() === "ACTIVE" ? "inactive" : "active";

      const res = await CompanyService.updatePlanStatus(item._id, {
        status: newStatus,
      });

      if (res?.status === 200) {
        toast.success("Status updated successfully");

        setPlan((prev) =>
          prev.map((i) =>
            i._id === item._id ? { ...i, status: newStatus.toUpperCase() } : i,
          ),
        );
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to update status");
    }
  };

  const featureColors: any = {
    face_detection: "primary",
    screen_recording: "warning",
    live_proctoring: "success",
    auto_flagging: "danger",
    id_verification: "info",
    report_generation: "dark",
  };

  const formatFeature = (feature: string) => {
    return feature.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  };

  return (
    <div className="plans-page">
      <Card className="shadow-sm border-0 plans-card">
        <Card.Body>
          {/* Header */}

          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h4 className="fw-bold mb-1">Subscription Plans</h4>
              <small className="text-muted">
                Manage subscription plans for companies
              </small>
            </div>

            <Button
              className="create-plan-btn"
              onClick={() => setShowModal(true)}
            >
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              Create Plan
            </Button>
          </div>

          {/* Search */}

          <Row className="mb-3">
            <Col md={4}>
              <div className="search-box">
                <FontAwesomeIcon icon={faSearch} className="search-icon" />
                <Form.Control
                  placeholder="Search plan..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          {/* Table */}

          <div className="table-responsive">
            <Table hover className="align-middle plans-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Plan Name</th>
                  <th>Price</th>
                  <th>Billing</th>
                  <th>Limits</th>
                  {/* <th>Features</th> */}
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {plan.map((item: any, index: number) => {
                  const users =
                    item.limits?.find((l: any) => l.key === "users")?.value ||
                    0;

                  const exams =
                    item.limits?.find((l: any) => l.key === "exams")?.value ||
                    0;

                  const proctors =
                    item.limits?.find((l: any) => l.key === "proctors")
                      ?.value || 0;

                  return (
                    <tr key={item._id}>
                      <td>{index + 1}</td>

                      <td className="fw-semibold">{item.name}</td>

                      <td>{item.price === 0 ? "Free" : `₹${item.price}`}</td>

                      <td className="text-capitalize">{item.billingCycle}</td>

                      {/* LIMITS */}

                      <td>
                        <div className="limit-badges">
                          <Badge bg="secondary" className="me-2">
                            <FontAwesomeIcon icon={faUsers} className="me-1" />
                            {users}
                          </Badge>

                          <Badge bg="secondary" className="me-2">
                            <FontAwesomeIcon
                              icon={faFileAlt}
                              className="me-1"
                            />
                            {exams}
                          </Badge>

                          <Badge bg="secondary">
                            <FontAwesomeIcon
                              icon={faUserTie}
                              className="me-1"
                            />
                            {proctors}
                          </Badge>
                        </div>
                      </td>

                      {/* FEATURES */}

                      {/* <td>
                        <div className="feature-wrapper">
                          {Array.isArray(item.features) &&
                            item.features.map((feature: string, i: number) => (
                              <Badge
                                key={i}
                                bg={featureColors[feature] || "secondary"}
                                className="feature-badge-table me-1 mb-1"
                              >
                                {formatFeature(feature)}
                              </Badge>
                            ))}
                        </div>
                      </td> */}

                      {/* STATUS */}

                      <td>
                        <span
                          className={`badge px-3 py-2 fw-semibold ${
                            item.status === "ACTIVE"
                              ? "bg-success bg-opacity-10 text-success border border-success"
                              : "bg-danger bg-opacity-10 text-danger border border-danger"
                          }`}
                        >
                          {item.status}
                        </span>
                      </td>

                      {/* ACTION */}

                      <td>
                        <Dropdown align="end">
                          <Dropdown.Toggle
                            variant="light"
                            className="action-btn"
                          >
                            <FontAwesomeIcon icon={faEllipsisV} />
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() =>
                                navigate(`/admin-dash/plan/view/${item._id}`)
                              }
                            >
                              <FontAwesomeIcon
                                icon={faEye}
                                className="me-2 text-secondary"
                              />
                              View Plan Detail
                            </Dropdown.Item>

                            <Dropdown.Item
                              onClick={() =>
                                navigate(`/admin-dash/plan/edit/${item._id}`)
                              }
                            >
                              <FontAwesomeIcon
                                icon={faPen}
                                className="me-2 text-primary"
                              />
                              Edit Plan
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => updateStatus(item)}>
                              <FontAwesomeIcon
                                icon={
                                  item.status?.toUpperCase() === "ACTIVE"
                                    ? faToggleOff
                                    : faToggleOn
                                }
                                className="me-2 text-warning"
                              />
                              Set{" "}
                              {item.status?.toUpperCase() === "ACTIVE"
                                ? "Inactive"
                                : "Active"}
                            </Dropdown.Item>

                            <Dropdown.Item
                              onClick={() =>
                                navigate(`/admin-dash/assign-plan`)
                              }
                            >
                              <FontAwesomeIcon
                                icon={faUsers}
                                className="me-2 text-info"
                              />
                              Assign plan
                            </Dropdown.Item>

                            <Dropdown.Divider />

                            <Dropdown.Item className="text-danger">
                              <FontAwesomeIcon
                                icon={faTrash}
                                className="me-2"
                              />
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </Card.Body>
        <TablePagination
          total={total}
          currentPage={currentPage}
          perPage={perPage}
          handlePageChange={(page: number) => setCurrentPage(page)}
          setPerPage={(size: number) => {
            setPerPage(size);
            setCurrentPage(1);
          }}
        />
      </Card>

      <CreatePlanModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        refreshPlans={getAllPlan}
      />
    </div>
  );
};

export default PlanList;
